import { useEffect, useState } from "react";
import { Hourglass } from "lucide-react";

export function StuckDirectorsStrip({ api }) {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    api.get("/admin/directors/journey/stuck", { params: { days: 7 } }).then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  }, [api]);
  if (!rows || rows.length === 0) return null;
  return (
    <div data-testid="stuck-directors-strip" className="mb-6 border border-[#C0392B]/40 bg-[#C0392B]/5 rounded-sm p-4">
      <div className="flex items-center gap-2 font-grotesk text-[9px] uppercase tracking-[0.34em] text-[#E0A070]">
        <Hourglass size={12} /> Journey digest · {rows.length} director{rows.length === 1 ? "" : "s"} stuck on a stage for more than 7 days
      </div>
      <ul className="mt-3 grid sm:grid-cols-2 lg:grid-cols-3 gap-2">
        {rows.map((r) => (
          <li key={r.id} data-testid={`stuck-director-${r.id}`} className="flex items-center justify-between gap-3 border border-white/10 bg-black/40 px-3 py-2">
            <div className="min-w-0">
              <div className="font-serif text-sm text-[#F5F5F0] truncate">{r.name || r.email}</div>
              <div className="font-grotesk text-[9px] uppercase tracking-[0.2em] text-[#8A8A82]">{r.completed}/7 · next: {r.next_title}</div>
            </div>
            <span className="font-mono text-[11px] text-[#E0A070] whitespace-nowrap">{r.days_stuck}d</span>
          </li>
        ))}
      </ul>
      <div className="mt-2 font-body text-[11px] text-[#8A8A82]">The same list is e-mailed to every admin in the Monday 09:00 IST weekly digest.</div>
    </div>
  );
}
